import React, { useEffect, useState } from "react";
import { getdaybook } from "../../../../services/admin";
import moment from "moment";
import baseUrl from "../../../../Api";
import { printReportUrl } from "../../../../utils/printPdf";

export default function Daybook() {
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
    const [daybookData, setDaybookData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchDaybook();
    }, []);

    const fetchDaybook = () => {
        setLoading(true);
        const data = {
            transaction_date: selectedDate,
            branch_id: localStorage.getItem("branch"),
        };

        getdaybook(data).then((res) => {
            if (res.status === true) {
                setDaybookData(res.data);
            }
            setLoading(false);
        });
    };

    const handleGenerate = () => {
        fetchDaybook();
    };

    const handleDownloadPDF = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        const url = `${baseUrl}/daybook/pdf?transaction_date=${selectedDate}&branch_id=${branchId}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Daybook_${moment(selectedDate).format('DD-MM-YYYY')}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading PDF:', error);
            alert('Error downloading PDF');
        });
    };

    // Print sends the same PDF the download button produces straight to the printer.
    const handlePrint = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        printReportUrl(`${baseUrl}/daybook/pdf?transaction_date=${selectedDate}&branch_id=${branchId}&output=html`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
    };

    const handleDownloadExcel = () => {
        const token = localStorage.getItem("token");
        const branchId = localStorage.getItem("branch");

        const url = `${baseUrl}/daybook/excel?transaction_date=${selectedDate}&branch_id=${branchId}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Daybook_${moment(selectedDate).format('DD-MM-YYYY')}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error downloading Excel:', error);
            alert('Error downloading Excel');
        });
    };

    const formatCurrency = (amount) => {
        return parseFloat(amount || 0).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Daybook</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Accounts</a>
                    </li>
                    <li className="breadcrumb-item">
                        <a>Reports</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Daybook
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4 className="card-title">Daybook (Daily Journal)</h4>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            {daybookData && (
                                                <>
                                                    <button className="btn btn-danger me-2" onClick={handleDownloadPDF}>
                                                        <i className="fa fa-file-pdf"></i> Download PDF
                                                    </button>
                                                    <button className="btn btn-success me-2" onClick={handleDownloadExcel}>
                                                        <i className="fa fa-file-excel"></i> Download Excel
                                                    </button>
                                                    <button className="btn btn-primary" onClick={handlePrint}>
                                                        <i className="fa fa-print"></i> Print
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <label className="form-label">Transaction Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={selectedDate}
                                        onChange={(e) => setSelectedDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleGenerate}
                                        disabled={loading}
                                    >
                                        <i className="fa fa-search"></i> {loading ? 'Loading...' : 'Generate'}
                                    </button>
                                </div>
                            </div>

                            {daybookData && (
                                <>
                                    <div className="text-center mb-4">
                                        <h5>Daybook</h5>
                                        <p className="text-muted">
                                            Date: {moment(daybookData.transaction_date).format('DD MMMM YYYY, dddd')}
                                        </p>
                                    </div>

                                    {daybookData.entries && daybookData.entries.length > 0 ? (
                                        <>
                                            {/* Group by Voucher */}
                                            {daybookData.entries.map((voucher, vIndex) => (
                                                <div key={vIndex} className="mb-4">
                                                    <div className="card">
                                                        <div className="card-header bg-light">
                                                            <div className="row">
                                                                <div className="col-md-8">
                                                                    <strong>Voucher: {voucher.voucher_number}</strong>
                                                                    {' '}
                                                                    <span className="badge bg-info">
                                                                        {voucher.voucher_type}
                                                                    </span>
                                                                    {' '}
                                                                    <span className="badge bg-secondary">
                                                                        {voucher.payment_mode}
                                                                    </span>
                                                                </div>
                                                                <div className="col-md-4 text-end">
                                                                    <strong>Amount: ₹ {formatCurrency(voucher.total_amount)}</strong>
                                                                </div>
                                                            </div>
                                                            {voucher.narration && (
                                                                <div className="row mt-2">
                                                                    <div className="col-12">
                                                                        <small className="text-muted">
                                                                            <em>{voucher.narration}</em>
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="card-body p-0">
                                                            <table className="table table-sm table-bordered mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th width="50%">Account</th>
                                                                        <th width="25%" className="text-end">Debit (₹)</th>
                                                                        <th width="25%" className="text-end">Credit (₹)</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {voucher.ledger_entries.map((entry, eIndex) => (
                                                                        <tr key={eIndex}>
                                                                            <td>
                                                                                {entry.account_code} - {entry.account_name}
                                                                                {entry.narration && entry.narration !== voucher.narration && (
                                                                                    <><br /><small className="text-muted"><em>{entry.narration}</em></small></>
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end text-success">
                                                                                {entry.debit_amount > 0
                                                                                    ? formatCurrency(entry.debit_amount)
                                                                                    : '-'}
                                                                            </td>
                                                                            <td className="text-end text-danger">
                                                                                {entry.credit_amount > 0
                                                                                    ? formatCurrency(entry.credit_amount)
                                                                                    : '-'}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    <tr className="table-secondary">
                                                                        <td><strong>Total</strong></td>
                                                                        <td className="text-end">
                                                                            <strong>{formatCurrency(voucher.total_debit)}</strong>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <strong>{formatCurrency(voucher.total_credit)}</strong>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                            {/* Grand Total */}
                                            <div className="card bg-primary text-white">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <h6>Total Vouchers</h6>
                                                            <h3>{daybookData.entries.length}</h3>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <h6>Total Debit</h6>
                                                            <h3>₹ {formatCurrency(daybookData.total_debit)}</h3>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <h6>Total Credit</h6>
                                                            <h3>₹ {formatCurrency(daybookData.total_credit)}</h3>
                                                        </div>
                                                    </div>
                                                    {daybookData.total_debit === daybookData.total_credit && (
                                                        <div className="row mt-3">
                                                            <div className="col-12 text-center">
                                                                <span className="badge bg-success">
                                                                    <i className="fa fa-check-circle"></i> Daybook is balanced
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="alert alert-info">
                                            <i className="fa fa-info-circle"></i> No transactions found for {moment(selectedDate).format('DD-MM-YYYY')}
                                        </div>
                                    )}
                                </>
                            )}

                            {!daybookData && !loading && (
                                <div className="text-center py-5">
                                    <i className="fa fa-calendar-day fa-3x text-muted mb-3"></i>
                                    <p className="text-muted">
                                        Select a date and click "Generate" to view the daybook
                                    </p>
                                    <p className="text-muted">
                                        <small>Daybook shows all transactions (vouchers) recorded on a specific day</small>
                                    </p>
                                </div>
                            )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
